/** Dateien für den Composer vormerken (Button, Drag & Drop, Einfügen) mit Prüfung gegen die Plattform-Limits. */
import { appState } from '../../store/app';
import { toast } from '../../store/ui';
import { formatBytes } from './format';
import type { DraftFile } from './send';
import { useMessagesUi } from './state';

let fileSeq = 0;

export function queueFiles(channelId: string, list: Iterable<File>, canAttach: boolean): number {
  const files = [...list];
  if (!files.length) return 0;
  if (!canAttach) {
    toast.error('Keine Berechtigung', 'Du darfst in diesem Kanal keine Dateien hochladen.');
    return 0;
  }
  const { maxUploadBytes, maxAttachmentsPerMessage } = appState().limits;
  const ui = useMessagesUi.getState();
  const current = ui.files[channelId] ?? [];
  const accepted: DraftFile[] = [];
  const tooBig: string[] = [];
  for (const file of files) {
    if (maxUploadBytes > 0 && file.size > maxUploadBytes) {
      tooBig.push(file.name);
      continue;
    }
    if (maxAttachmentsPerMessage > 0 && current.length + accepted.length >= maxAttachmentsPerMessage) {
      toast.error('Zu viele Dateien', `Höchstens ${maxAttachmentsPerMessage} Dateien pro Nachricht.`);
      break;
    }
    accepted.push({ id: `f${++fileSeq}`, file, spoiler: false });
  }
  if (tooBig.length) toast.error('Datei zu groß', `${tooBig.join(', ')} – erlaubt sind höchstens ${formatBytes(maxUploadBytes)} pro Datei.`);
  if (accepted.length) ui.setFiles(channelId, [...current, ...accepted]);
  return accepted.length;
}

export function removeFile(channelId: string, id: string): void {
  const ui = useMessagesUi.getState();
  ui.setFiles(channelId, (ui.files[channelId] ?? []).filter((f) => f.id !== id));
}

export function toggleSpoiler(channelId: string, id: string): void {
  const ui = useMessagesUi.getState();
  ui.setFiles(
    channelId,
    (ui.files[channelId] ?? []).map((f) => (f.id === id ? { ...f, spoiler: !f.spoiler } : f)),
  );
}
